import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled from 'styled-components';
import { Typography } from '../../Typography';
import { paddingAttributes, propsBlocker, getComponentOverride } from '../../../system';
export var DialogTitleRoot = styled.div.withConfig(propsBlocker)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    flex: 0 0;\n    color: red;\n    ", "\n    ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.componentOverrides.DialogTitle.Root.base;
}, paddingAttributes);
export var DialogTitleText = styled(Typography)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin: 0;\n"])));
export var DialogTitleDescription = styled(Typography)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    letter-spacing: 0;\n    ", ";\n\n    ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.componentOverrides.DialogTitle.Description.base;
}, getComponentOverride('DialogTitle'));